import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { PageSkeleton } from '@app/shared/components/PageSkeleton';

export const getMessages = (locale) => import(`../../../../build/translations/${locale}.json`);

export const createIntlProvider =
  (locale, getMessages) =>
  ({ initialMessages, children }) => {
    const [messages, setMessages] = useState(initialMessages);

    const setNoMessages = () => setMessages([]);

    useEffect(() => {
      if (messages) return;
      getMessages(locale).then(setMessages).catch(setNoMessages);
    }, [messages]);

    if (!messages) return <PageSkeleton />;

    return (
      <IntlProvider messages={messages} locale={locale} defaultLocale="es">
        {children}
      </IntlProvider>
    );
  };
